<template>
    <div style="font-weight: 500; display:flex; flex-direction: column;">
        <div style=" height:45px; display:flex; align-items: center;">
            <div style="flex: 1; position: relative;">
                <MercenaryHeader :title="'결과 보기'" :back-title="'뒤로가기'" :close-action="closeFindPositionPro"></MercenaryHeader>
                <div style="position: absolute; right: 12px; top: 10px;" @click="getShareUrl">
                    <img style="width: 18px;" :src="require('@/assets/img/share_white.png')" alt="">
                </div>
            </div>
        </div>
        <div ref="wrapper" @scroll="detectElement($event)" style="flex: 1; overflow-x: hidden;" :style="{ overflowY: showPosition ? 'scroll' : '' }">
            <div style="position: relative; flex: 1;">
                <div style="position: absolute; width: 100%;">
                    <Transition name="fade">
                        <div v-if="fade1 && !showPosition" style="position: absolute; top: -15px; width: 100%; transform: translateX(-50%); left: 50%; margin-top: 70px; margin-bottom: 28px; text-align:center; line-height: 28px; font-size:32px; font-weight: 700;">포지션 찾기<br><span style="display: inline-block; margin-top: 4px; font-size: 16px; font-weight: 500; line-height: 24px;">사커하우가 찾은 회원님의 축구 포지션입니다.</span></div>
                    </Transition>
                    <Transition name="fade">
                        <div v-if="fade2 && positionsArr.length > 0" style="position: relative;">
                            <div style="height:30px;"></div>
                            <div class="temp_name2" v-show="isShowCopyPicture" ref="fake_img" style="position: absolute; transition: all 1s;" :style="{
                                left: copy_picture_left + 'px',
                                top: (copy_picture_top - picture_top_gap) + 'px',
                                width: copy_picture_width + 'px',
                                transform: 'scaleX(' + copy_picture_scale_x + ')'
                            }">
                                <img :src="img_path" style="width:100%;">
                            </div>

                            <div v-show="isShowPositionPictures" ref="image_wrap" :class="positionsArr.length > 1 ? 'many_image' : 'one_image'" style="overflow-y: hidden; height: 360px; top: 124px;  width: 100%;">
                                <div :data-num='i' style="position: relative; opacity: 1; top: 130px; height: 160px; transition: opacity 1s" ref="images" v-for="each, i in positionsArr" :key="i" :style="{ visibility: curSelectedPictureIndex === i ? 'hidden' : '', opacity: positionPictureOpacity }">
                                    <img style=" width: 160px; " @click="showPositionResult(each.desc, i, result[each.desc].images[0])" :src="result[each.desc].images[0]">
                                    <div style="text-align: center; margin-top: 8px; font-weight: 500; font-size: 14px">{{ result[each.desc].explanation[0] }}</div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                    <Transition name="fade">
                        <div style="position: absolute; left: 50%; transform: translateX(-50%); width: 100%; top: 402px;" v-if="fade3 && !showPosition">
                            <div style="text-align: center; font-size: 12px; color: #606060;">그림을 눌러 내용을 확인할 수 있습니다.</div>
                        </div>
                    </Transition>
                </div>
            </div>
            <Transition name="fade">
                <div ref="result_wrap" v-if="showPosition" style="padding:20px; padding-bottom: 0;">
                    <div style="">
                        <div style="border-bottom: 1px solid #ededed; padding-bottom: 30px; text-align: center;">
                            <div style="font-size:24px; font-weight: 500; ">포지션 유형</div>
                            <div style="font-size:32px; font-weight:700;margin-top:16px;">{{ result[position].explanation[2] }}</div>
                            <div style="margin-top: 10px; font-weight: 400; font-size: 12px; color: #606060;">{{ result[position].explanation[1] }}</div>
                            <div style="margin-top: 32px;">
                                <img style="width: 226px;" :src="result[position].titleImage" alt="">
                            </div>
                        </div>

                        <div style="padding-bottom:32px; margin-top: 32px; border-bottom: 1px solid #ededed;">
                            <div style="margin-top: 20px;">
                                <div style="margin-bottom: 16px; font-size: 20px; font-weight: 500;">월드클래스 {{ result[position].explanation[0] }} 선수</div>
                                <div style="line-height: 28px; font-weight: 500;">회원님의 포지션에서 뛰는 대표적인 선수들입니다</div>
                            </div>
                            <div style="display:flex; gap: 24px; overflow-x: scroll; overflow-y: hidden; margin: 0 -20px; padding: 0 20px; margin-top: 16px; " class="hide_scroll">
                                <div>
                                    <img :src="result[position].images[1]" style="width:150px; border-radius: 50%;">
                                    <div class="player_name">{{ result[position].names[1] }}</div>
                                </div>
                                <div>
                                    <img :src="result[position].images[2]" style="width:150px; border-radius: 50%;">
                                    <div class="player_name">{{ result[position].names[2] }}</div>
                                </div>
                                <div style="">
                                    <img :src="result[position].images[3]" style="width:150px; border-radius: 50%;">
                                    <div class="player_name">{{ result[position].names[3] }}</div>
                                </div>
                                <div>
                                    <img :src="result[position].images[4]" style="width:150px; border-radius: 50%;">
                                    <div class="player_name">{{ result[position].names[4] }}</div>
                                </div>
                            </div>
                        </div>

                        <div style="margin: 32px 0; border-bottom: 1px solid #ededed; padding-bottom: 32px;">
                            <div style="margin-bottom: 10px; font-size:20px; font-weight: 500">코멘트</div>
                            <div v-html="result[position].explanation[3]" style="line-height:23px; font-weight: 500; font-size: 14px;"></div>
                            <div style="margin-top:8px; color: #808080; font-weight: 500; font-size: 12px;">{{ result[position].explanation[4] }}</div>
                        </div>

                        <!-- <div style="width: calc(100% + 40px); margin-left: -20px; height: 10px; background-color: #f5f5f5;"></div> -->

                        <div style="padding-bottom: 30px; border-bottom: 1px solid #ededed">
                            <div class="subTitle">{{ result[position].explanation[5] }}</div>
                            <div style="margin-bottom: 30px;" class="explanation">{{ result[position].explanation[6] }}</div>
                            <div class="explanation">{{ result[position].explanation[7] }}</div>
                        </div>
                    </div>
                    <div style="background-color: #210F03; border-radius: 24px; border-top: 1px solid #d9d9d9; border-bottom: 1px solid #d9d9d9; padding: 0 20px; margin-top: 32px;">
                        <div style="margin-top: 70px; margin-bottom: 40px; text-align: center;">
                            <img style="width: 80%" :src="result[position].images_pos[0]" alt="">
                        </div>
                        <div style="padding-bottom: 45px; color: #fff;" class="explanation">{{ result[position].explanation[12] }}</div>
                    </div>
                    <div style="margin-top: 32px; margin-bottom: 32px;">
                        <div style="margin-bottom: 20px; font-weight: 500; font-size: 20px;">포지션 카드</div>
                        <div style="text-align: center;">
                            <img style="width: 254px;" :src="result[position].images_pos[1]" alt="">
                        </div>
                        <div style="margin-top: 48px; font-size: 20px; font-weight: 500; margin-bottom: 16px;">{{ result[position].explanation[13] }}</div>
                        <div class="explanation">{{ result[position].explanation[10] }}</div>
                    </div>
                    <div style="width: calc(100% + 40px); margin-left: -20px; height: 10px; margin-bottom: 32px; background-color: #f5f5f5;"></div>
                    <div ref="ability_element">
                        <div style="margin-bottom: 24px;">능력치 분석</div>
                        <AbilityAnalysis title="시야" :isFirst="true" :isCloseElement="isCloseElement" :showFeedBack="showFeedEyeSight" backGroundAndTextColor="#AADBDB" :good="eye_sight_good" :bad="eye_sight_bad" :feedBackContents="isEyeSightBad ? feedBackContents.eye_sight.bad.title : feedBackContents.eye_sight.good.title"></AbilityAnalysis>
                        <AbilityAnalysis title="패스 / 킥" :isCloseElement="isCloseElement" :showFeedBack="showFeedPass" backGroundAndTextColor="#EF4036" :good="pass_good" :bad="pass_bad" :feedBackContents="isPassBad ? feedBackContents.pass.bad.title : feedBackContents.pass.good.title"></AbilityAnalysis>
                        <AbilityAnalysis title="공 제어 감각" :isCloseElement="isCloseElement" :showFeedBack="showFeedBallCont" backGroundAndTextColor="#FFD41E" :good="ball_cont_good" :bad="ball_cont_bad" :feedBackContents="isBallContBad ? feedBackContents.ball_control.bad.title : feedBackContents.ball_control.good.title"></AbilityAnalysis>
                        <AbilityAnalysis title="체력 유지율" :isCloseElement="isCloseElement" :showFeedBack="showFeedHealth" backGroundAndTextColor="#F28801" :good="health_good" :bad="health_bad" :feedBackContents="isHealthBad ? feedBackContents.health.bad.title : feedBackContents.health.good.title"></AbilityAnalysis>
                        <AbilityAnalysis title="주력" :isCloseElement="isCloseElement" :showFeedBack="showFeedMainForce" backGroundAndTextColor="#93CBA6" :good="main_force_good" :bad="main_force_bad" :feedBackContents="isMainForceBad ? feedBackContents.speed.bad.title : feedBackContents.speed.good.title"></AbilityAnalysis>
                    </div>
                    <div style="margin-bottom: 40px; margin-top: 32px">
                        <div style="color: #2d1404; margin-bottom: 12px; font-size: 20px; font-weight: 500; font-size: 20px; line-height: 24px;">포지션 종합 평가</div>
                        <div style="color: #2D1404; font-weight: 700; margin-bottom: 12px; line-height: 24px;">{{ result[position].explanation[14] }}</div>
                        <div style="color: #2D1404; font-size: 14px; font-weight: 500;" class="explanation">{{ result[position].explanation[15] }}</div>
                    </div>
                    <div style="border-radius: 12px; background-color: #f5f5f5; margin-top: 32px; padding-bottom: 32px;">
                        <div style="text-align: center; padding-top: 32px;">
                            <img style="width: 136px;" :src="require('@/assets/img/lite_ground.png')" alt="">
                        </div>
                        <div style="margin-top: 16px; font-size: 20px; font-weight: 500; line-height: 24px; text-align: center">웹에서 할 수 있는 포지션 찾기 Lite</div>
                        <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-top: 16px; text-align: center">지금 바로 무료로 포지션을 찾을 수 있습니다</div>
                        <div @click="startPositionLite" style="width: 166px; height: 48px; border-radius: 50px; background-color: var(--color-main); margin: 0 auto; text-align: center; line-height: 48px; font-size: 14px; font-weight: 700; margin-top: 16px;">포지션 찾기 Lite 시작하기</div>
                    </div>
                </div>
            </Transition>
        </div>
        <div v-if="showPosition && this.showGraph" style=" display:flex; flex-direction: column; align-items: center; gap: 10px; justify-content: center; padding: 20px 0; padding-top: 0">
            <div @click="applyProPosition" class="common_btn">내 프로필에 적용하기</div>
        </div>
        <ModalFrameBasic :isOpen="isShowHealth" :closeModal="closeModal">
            <div style="margin-top: 10px; position: absolute; right: 20px; z-index: 10;">
                <div style="" class="circle" @click="closeModal"><img :src="require('@/assets/img/black_x_btn_new.png')" style="width:18px;"></div>
            </div>
            <div style="margin-top: 10px; text-align: center; position: relative;">
                <object :data="isHealthBad ? feedBackContents.health.bad.img_path : feedBackContents.health.good.img_path" alt=""></object>
            </div>
            <div class="sub_title_modal">{{ isHealthBad ? feedBackContents.health.bad.subTitle : feedBackContents.health.good.subTitle }}</div>
            <div class="contents_modal">{{ isHealthBad ? feedBackContents.health.bad.contents : feedBackContents.health.good.contents }}</div>
        </ModalFrameBasic>
        <ModalFrameBasic :isOpen="isShowBallCont" :closeModal="closeModal">
            <div style="margin-top: 10px; position: absolute; right: 20px; z-index: 10;">
                <div style="" class="circle" @click="closeModal"><img :src="require('@/assets/img/black_x_btn_new.png')" style="width:18px;"></div>
            </div>
            <div style="margin-top: 10px; text-align: center;">
                <object :data="isBallContBad ? feedBackContents.ball_control.bad.img_path : feedBackContents.ball_control.good.img_path" alt=""></object>
            </div>
            <div class="sub_title_modal">{{ isBallContBad ? feedBackContents.ball_control.bad.subTitle : feedBackContents.ball_control.good.subTitle }}</div>
            <div class="contents_modal">{{ isBallContBad ? feedBackContents.ball_control.bad.contents : feedBackContents.ball_control.good.contents }}</div>
            <div v-if="isBallContBad" style="margin-top: 30px;">
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.ball_control.bad.subTitle2 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.ball_control.bad.contents2 }}</div>
                </div>
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.ball_control.bad.subTitle3 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.ball_control.bad.contents3 }}</div>
                </div>
            </div>
        </ModalFrameBasic>
        <ModalFrameBasic :isOpen="isShowPass" :closeModal="closeModal">
            <div style="margin-top: 10px; position: absolute; right: 20px; z-index: 10;">
                <div style="" class="circle" @click="closeModal"><img :src="require('@/assets/img/black_x_btn_new.png')" style="width:18px;"></div>
            </div>
            <div style="margin-top: 10px; text-align: center;">
                <object :data="isPassBad ? feedBackContents.pass.bad.img_path : feedBackContents.pass.good.img_path" alt=""></object>
            </div>
            <div class="sub_title_modal">{{ isPassBad ? feedBackContents.pass.bad.subTitle : feedBackContents.pass.good.subTitle }}</div>
            <div class="contents_modal">{{ isPassBad ? feedBackContents.pass.bad.contents : feedBackContents.pass.good.contents }}</div>
            <div style="margin-top: 30px;">
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.pass.bad.subTitle2 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.pass.bad.contents2 }}</div>
                </div>
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.pass.bad.subTitle3 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.pass.bad.contents3 }}</div>
                </div>
            </div>
        </ModalFrameBasic>
        <ModalFrameBasic :isOpen="isShowEyeSight" :closeModal="closeModal">
            <div style="margin-top: 10px; position: absolute; right: 20px; z-index: 10;">
                <div style="" class="circle" @click="closeModal"><img :src="require('@/assets/img/black_x_btn_new.png')" style="width:18px;"></div>
            </div>
            <div style="margin-top: 10px; text-align: center;">
                <object :data="isEyeSightBad ? feedBackContents.eye_sight.bad.img_path : feedBackContents.eye_sight.good.img_path" alt=""></object>
            </div>
            <div class="sub_title_modal">{{ isEyeSightBad ? feedBackContents.eye_sight.bad.subTitle : feedBackContents.eye_sight.good.subTitle }}</div>
            <div class="contents_modal">{{ isEyeSightBad ? feedBackContents.eye_sight.bad.contents : feedBackContents.eye_sight.good.contents }}</div>
            <div v-if="isEyeSightBad" style="margin-top: 30px;">
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.eye_sight.bad.subTitle2 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.eye_sight.bad.contents2 }}</div>
                </div>
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.eye_sight.bad.subTitle3 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.eye_sight.bad.contents3 }}</div>
                </div>
            </div>
        </ModalFrameBasic>
        <ModalFrameBasic :isOpen="isShowMainForce" :closeModal="closeModal">
            <div style="margin-top: 10px; position: absolute; right: 20px; z-index: 10;">
                <div style="" class="circle" @click="closeModal"><img :src="require('@/assets/img/black_x_btn_new.png')" style="width:18px;"></div>
            </div>
            <div style="margin-top: 10px; text-align: center;">
                <object :data="isMainForceBad ? feedBackContents.speed.bad.img_path : feedBackContents.speed.good.img_path" alt=""></object>
            </div>
            <div class="sub_title_modal">{{ isMainForceBad ? feedBackContents.speed.bad.subTitle : feedBackContents.speed.good.subTitle }}</div>
            <div class="contents_modal">{{ isMainForceBad ? feedBackContents.speed.bad.contents : feedBackContents.speed.good.contents }}</div>
            <div style="margin-top: 30px;">
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.speed.good.subTitle2 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.speed.bad.contents2 }}</div>
                </div>
                <div style="margin-bottom: 20px;">
                    <div class="sub_title2_modal">{{ feedBackContents.speed.bad.subTitle3 }}</div>
                    <div class="sub_contents2_modal">{{ feedBackContents.speed.bad.contents3 }}</div>
                </div>
            </div>
        </ModalFrameBasic>
    </div>
</template>

<script>
import { AbilityAnalysis, ModalFrameBasic } from '@/components/common'
import { FIND_POSITION_PRO_TITLE } from '../../Constants'
import ResponseCode from "../../ResponseCode";
import MercenaryHeader from '@/components/common/MercenaryHeader'

export default {
    name: 'FindPositionProResult',
    components: { AbilityAnalysis, ModalFrameBasic, MercenaryHeader },
    props: {
        positionsArr: {
            type: Array,
            default: () => { }
        },
        groupedData: {
            type: Object,
            default: () => { }
        },
        showGraph: {
            type: Boolean,
            default: true,
        },
        isTopBtnHidden: {
            type: Boolean,
            default: false,
        },
        isConfirmDirectClose: {
            type: Boolean,
            default: false
        },
        position_result_history_group_key: {
            type: [String, Number],
            default: null
        },
        isFromProfile: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        result() {
            return {
                CF: {
                    explanation: [
                        '중앙 공격수',
                        'Center Forward',
                        '중앙 공격수 (CF)',
                        '"스트라이커의 역할은 이제 더 이상 골을<br>넣는 것에만 한정지을 수 없다."',
                        '조나단 윌슨',
                        '오직 득점을 위해서 뛰세요',
                        '재빠르며 도전적이고, 좋은 피지컬과 개인기량을 갖춘 중앙 공격수 (CF)는 팀을 승리로 이끌어내는 상당히 중요한 역할을 해요! ',
                        '현대 축구에서 중앙 공격수는 빠르고, 훌륭한 마무리 능력을 가지고 있어야 하며, 팀원들과 효과적인 콤비네이션 플레이를 할 수 있도록 기회를 잘 옅봐야 하죠. 최근에는 상대 수비수에게 압력을 가함으로써 수비를 지원하고 상대편의 빌드업 플레이를 저지하여 또 다른 기회를 창출하기도 해요.',
                        '골 냄새를 맡고 공을 호시탐탐 노리고 있는 거죠 :) 그냥 골을 주워 먹는 역할이라 생각할 수 있지만, 어떻게 하면 현재의 흐름에서 골을 넣을 수 있을지를 계속 생각하고, 플레이를 만들며 마무리를 지어야 하기에 생각보다 지능적으로 플레이를 해야 하죠.',
                        '동물적인 감각과 순발력!',
                        '또한 볼 득점뿐만 아니라 빌드업 되는 흐름과 상대 진영의 공간들을 잘 파악하고, 후방에 있는 선수들에게 볼을 효율적으로 패스하여 득점을 만들도록 유도하는 플레이도 만들 수 있어야 합니다. ',
                        '매사에 빠르고 정확한 결정을 내릴줄 알며, 좋은 피지컬과 개인기량을 갖추어 기회가 되는 순간을 동물적인 감각으로 파악하여 마무리 지을 줄 아는 ' + this.nic_name + ' 회원님, 당신은 중앙 공격수입니다 :)',
                        '“골 냄새를 맡고 공을 호시탐탐 노리고 있는 거예요. 단순히 골을 주워 먹는 역할이라 생각할 수 있지만, 어떻게 하면 현재의 흐름에서 골을 넣을 수 있을지를 계속 생각하고 플레이를 만들며 마무리를 지어야 하기에 생각보다 지능적으로 플레이를 해야 하죠.”',
                        '골 메이커 (Goal maker)',
                        '동물적인 감각과 순발력',
                        '매사에 빠르고 정확한 결정을 내릴줄 알며, 좋은 피지컬과 개인 기량을 갖추어 기회가 되는 순간을 동물적인 감각으로 파악하여 마무리 지을 줄 아는 ' + this.nic_name + ' 회원님! 중앙 공격수라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_cf_로베르트 레반도프스키.png'),
                        require('@/assets/myposition_cf_로베르트 레반도프스키.png'),
                        require('@/assets/myposition_cf_헤리 케인.png'),
                        require('@/assets/myposition_cf_카림 벤제마.png'),
                        require('@/assets/myposition_cf_엘링 홀란드.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_cf.svg'),
                        require('@/assets/pro_img/myposition_cf.png')
                    ],
                    names: [
                        '', '로베르트 레반도프스키', '헤리 케인', '카림 벤제마', '엘링 홀란드'
                    ],
                    titleImage: require(`@/assets/img/position_CF.png`)
                },
                SS: {
                    explanation: [
                        '세컨드 스트라이커',
                        'Second Striker',
                        '세컨드 스트라이커 (SS)',
                        '"그는 항상 스트라이커였지만 스트라이커는 아니었다. <br>미드필더이지만 미드필더도 아니었다."',
                        '아르센 벵거',
                        '강려한 공격력을 가진 최전방 서포터',
                        '날카로우면서도, 폭발적이고, 뛰어난 개인기량을 통해 압박을 벗어나 공격에 가담하는 세컨컨드 스트라이커 (SS)는 중앙 공격수를 도와 득점 찬스를 만들어내거나 득점을 직접 올려 승리를 이끌어내는 역할을 해요.',
                        '현대 축구에서 세컨드 스트라이커는 빠르고 효과적으로 패스를 연계할 수 있도록 기본적인 기량이 뛰어나야 하며, 공간에 대한 지각능력과 넓은 시야각을 가지고 있어야 하죠. 상황에 따라서 직접 득점을 할 수 있도록 득점 능력까지도 좋아야하는 상당한 난이도를 가진 포지션이예요.',
                        '득점’이라는 요리를 만드는 쉐프라고 할 수 있어요. 공격형 미드필더와 차이가 없다고 생각할 수 있지만, 스트라이커로서의 역할과 공격형 미드필더로서의 역할을 같이 소화하며 활약하는만큼 공격력이 압도적으로 높아야 하는 역할이죠.',
                        '노련미 넘치는 뇌지컬과 피지컬',
                        '공간 창출, 흐름 통제, 압박 해소, 칼 같은 전진 패스, 화려하면서도 효과적인 턴 스킬 등의 퍼포먼스, 높은 득점 능력을 모두 필요로 하는만큼 상당히 지능적으로 움직여야 해요. 이 모든 것들을 소화하려면 기술적으로도 훌륭한 수준이어야합니다. 마치 올라운더 ‘골 기획자’인 것처럼요!',
                        '뇌지컬만큼이나 피지컬도 뛰어난 ' + this.nic_name + ' 회원님, 당신은 세컨드 스트라이커입니다 :)',
                        '‘득점’이라는 요리를 만드는 쉐프라고 할 수 있어요. 공격형 미드필더와 차이가 없다고 생각할 수 있지만, 스트라이커로서의 역할과 공격형 미드필더로서의 역할을 같이 소화하며 활약하는만큼 공격력이 압도적으로 높아야 하는 역할이죠.',
                        '올라운더 골 기획자',
                        '노련미 넘치는 뇌지컬과 피지컬',
                        '뇌지컬만큼이나 피지컬도 뛰어난 ' + this.nic_name + ' 회원님! 세컨드 스트라이커라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_ss_데니스 베르캄프.png'),
                        require('@/assets/myposition_ss_데니스 베르캄프.png'),
                        require('@/assets/myposition_ss_앙투안 그리즈만.png'),
                        require('@/assets/myposition_ss_알레산드로 델피에로.png'),
                        require('@/assets/myposition_ss_웨인 루니.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_ss.svg'),
                        require('@/assets/pro_img/myposition_ss.png')
                    ],
                    names: [
                        '', '데니스 베르캄프', '앙투안 그리즈만', '알레산드로 델피에로', '웨인 루니'
                    ],
                    titleImage: require(`@/assets/img/position_SS.png`)
                },
                WF: {
                    explanation: [
                        '윙 포워드',
                        'Wing Forward',
                        '윙 포워드 (WF)',
                        '"만약 축구에 마술이 존재한다면 그것은 모든 상황에<br>대비하기 위한 많은 훈련과 노력에서 나오는 것이다."',
                        '호나우지뉴',
                        '저돌적이고 빠른 돌파와 폭발적인 기량',
                        '빠르고 재치있는 퍼포먼스를 선보이고 공간을 휘젓고 다니면서 공격에 직접 가담하는 윙 포워드 (WF)는 빠른 스피드로 공격의 흐름을 바꿀 수 있는 역할을 해요.',
                        '현대 축구에서 윙 포워드는 저돌적으로 돌파하여 공격 찬스를 만들어내는 역할을 하는만큼 드리블면에서 기술적으로 매우 뛰어나야하며, 대체로 발 동작이 빠르거나 스피드가 빠른 선 수들이 윙 포워드 포지션에서 뛰곤 해요. 중앙으로 침투해 득점을 올려야 하는 경우도 있어 득점 능력도 상당히 우수해야 하고 체력적으로도 뛰어나야 하는 포지션이죠.',
                        '축구에서 가장 드라마틱한 포지션이라고 생각하셔도 돼요. 치고 달리면서 빠르게 올라와 중앙까지 침투, 수비수를 앞두고 한 번 접은 뒤 바로 슛. 그리고 골. 가장 축구다운 장면이 만들어지는 거죠. 물론 그만큼 개인기량이 좋아야겠지만요.',
                        '벽을 뚫는 날개짓',
                        '일반적으로 윙어는 자신이 뛰는 위치와 사용하는 발을 같이 하곤 했는데, 최근에는 주로 사용하는 발로 슈팅을 연결하기 위해 오히려 반대 측면에서 뛰는 ‘인버티드 윙어’도 전략적으로 늘어나고 있어요. ‘인버티드 윙어’는 강한 날갯짓으로 중앙까지 파고 들어요. 벽을 뚫는 모습과도 같죠.',
                        '빠르고 강한 움직임으로 상대 진영을 저돌적으로 파고드는 ' + this.nic_name + ' 회원님, 당신은 세컨드 스트라이커입니다 :)',
                        '축구에서 가장 드라마틱한 포지션이라고 생각하셔도 돼요. 치고 달리면서 빠르게 올라와 중앙까지 침투, 수비수를 앞두고 한 번 접은 뒤 바로 슛. 그리고 골. 가장 축구다운 장면이 만들어지는 거죠. 물론 그만큼 개인기량이 좋아야겠지만요.',
                        '강철 날개',
                        '벽을 뚫는 날갯짓',
                        '빠르고 강한 움직임으로 상대 진영을 저돌적으로 파고드는 ' + this.nic_name + ' 회원님! 윙 포워드라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_wf_손흥민.png'),
                        require('@/assets/myposition_wf_리오넬 메시.png'),
                        require('@/assets/myposition_wf_손흥민.png'),
                        require('@/assets/myposition_wf_크리스티아누 호날두.png'),
                        require('@/assets/myposition_wf_킬리안 음바페.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_wf.svg'),
                        require('@/assets/pro_img/myposition_wf.png')
                    ],
                    names: [
                        '', '리오넬 메시', '손흥민', '크리스티아누 호날두', '킬리안 음바페'
                    ],
                    titleImage: require(`@/assets/img/position_WF.png`)
                },
                AM: {
                    explanation: [
                        '공격형 미드필더',
                        'Attacking Midfielder',
                        '공격형 미드필더 (AM)',
                        '"축구는 테니스가 아니다.<br>때로는 터프한 플레이가 필요하다."',
                        '거스 히딩크',
                        '압도적인 기량의 플레이메이커',
                        '과감하고 도전적이며 능수능란하게 공격의 판을 만들어내는 이름하여 ‘공격 기획자’ 공격형 미드필더 (AM)는 뛰어난 드리블 기술로 수비 압박을 이겨낸 후에 공격수에게 공을 정확하게 연결해주는 역할을 하죠.',
                        '현대 축구에서 공격형 미드필더는 상대의 수비 전략이 펼쳐 지는 가운데서 치열한 압박을 뚫고 공격을 연계해야 하기에 드리블 능력, 패스 전달 능력과 킥력이 전체적으로 좋아야 해요. 또 상대 수비 진영을 교묘하게 파고 들어야 하기에 위치선정 능력 또한 좋아야 하죠. 또한 압박의 강도가 점점 거세지는 현대 축구의 특성상 체력, 피지컬적으로도 많은 요구사항이 생겼어요!',
                        '레고를 가지고 놀듯’ 플레이를 한다고 생각해볼까요? 기가 막히게 수비진영을 해체하고, 공격로를 조립하여 창의적으로 골을 만들어주고 승리를 이끌어 내는 거죠! 혹은 직접 슛을 하여 골을 만들어낼 수도 있는 정말 매력적이고 ‘축구 재밌게 하는’ 포지션인 거예요.',
                        '안되는 것도 되게 한다!',
                        '매우 감각적인 움직임으로 공격을 컨트롤하는 포지션의 특성상 굉장히 창의적이고 센스티브한 패스 플레이를 종종 목격할 수  있어요. 불가능한 건 없어요. 우리팀 공격수들이 집중 마크를  당하고 있을 때도 직접 파고들거나 말도 안되는 크로스를  올려주면서 심플하게 마무리를 지을 수 있으니까요!',
                        '',
                        '‘레고를 가지고 놀듯’ 플레이를 한다고 생각해볼까요? 기가 막히게 수비진영을 해체하고, 공격로를 조립하여 창의적으로 골을 만들어주고 승리를 이끌어 내는 거죠! 혹은 직접 슛을 하여 골을 만들어낼 수도 있는 정말 매력적이고 ‘축구 재밌게 하는’ 포지션인 거예요.',
                        '센스티브 플레이 메이커',
                        '안되는 것도 되게 한다',
                        '축구를 참 쉽게 할 수 있고, 팀의 중추가 되는 플레이메이커인 ' + this.nic_name + ' 회원님! 공격형 미드필더라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_am_지네딘 지단.png'),
                        require('@/assets/myposition_am_토마스 뮐러.png'),
                        require('@/assets/myposition_am_지네딘 지단.png'),
                        require('@/assets/myposition_am_브루노 페르난데스.png'),
                        require('@/assets/myposition_am_케빈 더 브라위너.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_am.svg'),
                        require('@/assets/pro_img/myposition_am.png')
                    ],
                    names: [
                        '', '토마스 뮐러', '지네딘 지단', '브루노 페르난데스', '케빈 더 브라위너'
                    ],
                    titleImage: require(`@/assets/img/position_AM.png`)
                },
                CM: {
                    explanation: [
                        '중앙 미드필더',
                        'Center Midfielder',
                        '중앙 미드필더 (CM)',
                        '"다른 것은 없다. 오직 축구공이다.<br>축구공을 위해 온 몸을 희생한다."',
                        '크리스찬 비에리',
                        "튼튼하고 안정적인 코어",
                        '그라운드의 가장 중앙, 전략적인 요충지에서 주로 활약하며, 팀의 공,수 전략의 핵심을 담당하는 중앙 미드필더 (CM)는 중앙에서 공격, 수비에 가담하여 공을 점유하고 전달하는 핵심적인 역할을 하죠.',
                        '현대 축구에서 중앙 미드필더는 중앙에서 공을 전달해주어야 하기에 볼 배급 능력이 매우 중요하며, 중앙에서 거센 압박을 이겨내면서 공을 지켜야 되기 때문에 가장 활발하게 움직여야 해요. 즉, 체력도 좋아야 하고, 기술적인 부분도 좋아야 하죠. 또한 어느 쪽에든 공을 원활하게 전달해야 하기에 도전적이라기 보다는 안정적으로 패스를 잘 주는 게 중요한 포지션이예요.',
                        '심장은 몸 전체에 피를 전달해요. 중앙 미드필더는 그라운드의 심장인셈이죠. 어디에든 안정적으로 공을 전달할 수 있는 팀의 전략적인 코어인 거예요. 수비시에는 수비 가담도 하고, 공격시에는 공격 포인트를 만들어주는 ‘커멘드 센터’ 같은 포지션이죠!',
                        '전천후 서포터',
                        '홀딩 미드필더보다 높은 위치에서 뛰어난 체력과 활동량을 바탕으로 공,수를 오가며 다양한 역할을 수행하는 전천후 플레이어인 박스 투 박스(box to box) 미드필더는 공을 배송해주는 역할도 물론 수행하지만 여러 상황에서 팀을 도와주고 공을 받아주는 든든한 서포터 역할을 하기도 해요.다방면으로 뛰어난 기량을 가지고 있는 만능 플레이어인 거죠. 그러나 전술의 발전으로 점점 보기 드물어지는 역할이기도 해요. ',
                        '',
                        '심장은 몸 전체에 피를 전달해요. 중앙 미드필더는 그라운드의 심장인셈이죠. 어디에든 안정적으로 공을 전달할 수 있는 팀의 전략적인 코어인 거예요. 수비시에는 수비 가담도 하고, 공격시에는 공격 포인트를 만들어주는 ‘커멘드 센터’ 같은 포지션이죠!',
                        '커멘드 센터',
                        '전천후 서포터',
                        '그라운드에서 핵심적인 역할을 수행하며, 상황에 따라 다방면으로 도움을 주는 ' + this.nic_name + ' 회원님! 중앙 미드필더라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_cm_차비 에르난데스.png'),
                        require('@/assets/myposition_cm_토니 크로스.png'),
                        require('@/assets/myposition_cm_주드 벨링엄.png'),
                        require('@/assets/myposition_cm_차비 에르난데스.png'),
                        require('@/assets/myposition_cm_프랭키 더 용.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_cm.svg'),
                        require('@/assets/pro_img/myposition_cm.png')
                    ],
                    names: [
                        '', '토니 크로스', '주드 벨링엄', '차비 에르난데스', '프랭키 더 용'
                    ],
                    titleImage: require(`@/assets/img/position_CM.png`)
                },
                WM: {
                    explanation: [
                        '측면 미드필더',
                        'Wide Midfielder',
                        '측면 미드필더 (WM)',
                        '"뛰어난 킥은 하루만에 만들어지지 않는다.<br>수천 수만 번의 노력으로 탄생하는 것이다."',
                        '데이비드 베컴',
                        '바람같은 움직임',
                        '헌신적이고, 빠른 움직임과 정확한 크로스 능력을 갖추고, 수비시엔 측면에서 압박을 가하는 측면 미드필더 (LM,RM)는 측면에서 중앙으로의 볼 배급과 동시에 상대의 볼 배급을 막아주는 역할을 해요.',
                        '현대 축구에서 윙 포워드와 측면 미드필더의 경계가 점점 모호해지는 추세이지만, 여전히 점유율 혹은 공수 밸런스를 촘촘하게 유지하는 전술에서는 다양하게 기용되죠. 주 활동 범위는 측면이지만, 활동량이 많기에 높은 체력이 요구되며, 킥력과 개인기량이 높아야 해요.',
                        '축구장 측면에서 시원한 바람처럼 움직이죠. 복잡한 빌드업이 필요한가요? 중원에서부터 압박을 이겨내고 빠르게 돌파해 골문 앞까지 얼리크로스를 올려주세요! 골까지 다이렉트로 연결해주는 거예요.',
                        '“심최몇?” 심장 최소 여러 개.',
                        '상황에 따라 오버랩핑을 해가며, 공격과 수비 양쪽을 적극적으로 가담하는 역할을 하기에 체력적으로 굉장히 뛰어나며, 놀라운 활동량을 자랑해요. 잔잔한 바람이 아닌 강철 바람인 거죠.',
                        '',
                        '축구장 측면에서 시원한 바람처럼 움직이죠. 복잡한 빌드업이 필요한가요? 중원에서부터 압박을 이겨내고 빠르게 돌파해 골문 앞까지 얼리크로스를 올려주세요! 골까지 다이렉트로 연결해주는 거예요.',
                        '강철 바람',
                        '“심최몇?” 심장 최소 여러 개',
                        '지치지 않는 체력으로 그라운드의 측면에서 거센 돌풍을 일으켜 상대팀을 혼란스럽게 하는 ' + this.nic_name + ' 회원님! 측면 미드필더 (LM,RM)라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_wm_박지성.png'),
                        require('@/assets/myposition_wm_모하메드 살라.png'),
                        require('@/assets/myposition_wm_데이비드 베컴.png'),
                        require('@/assets/myposition_wm_루이스 피구.png'),
                        require('@/assets/myposition_wm_박지성.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_wm.svg'),
                        require('@/assets/pro_img/myposition_wm.png')
                    ],
                    names: [
                        '', '모하메드 살라', '데이비드 베컴', '루이스 피구', '박지성'
                    ],
                    titleImage: require(`@/assets/img/position_WM.png`)
                },
                DM: {
                    explanation: [
                        '수비형 미드필더',
                        'Defensive Midfielder',
                        '수비형 미드필더 (DM)',
                        '"공을 소유하는 것이 곧 수비이다. 우리가 공을 갖고<br>있을 때, 상대 팀은 공격을 할 수 없기 때문이다."',
                        '펩 과르디올라',
                        '그라운드 중앙에 세워진 높은 벽',
                        '중앙 최후방에서 공을 캐치하고, 볼을 직접적으로 연결해 경기 흐름을 순식간에 바꿀 수 있는 수비형 미드필더 (DM)은 위협적인 공격력을 가진 공격수에 압박을 가해 저지하고, 직접적으로 볼을 배급하고, 빌드업을 해나가는 역할을 해요.',
                        '현대 축구에서는 전술적으로 전방 압박을 중요시하기에 상대적으로 최후방에 있는 수비형 미드필더가 볼을 직접 배급하는 역할이 커졌어요. 대인 방어, 지역 방어와 더불어 공격 흐름을 만들기 위한 패스 능력이 뛰어나야 하기에 수비형 미드필더라는 역할은 굉장히 전문적이며, 지능적이기에 누구나 할 수 있는 쉬운 포지션은 아니죠.',
                        '가운데 세워진 벽이 공격수를 자유롭게 따라다녀요. 무서운 벽이죠. 공이 오는 것들을 모두 잘라내고 볼을 가지고 난 후부터 바로 공격이 시작되는 거예요. 수비적인 역할만 할 거라고 생각하면 안돼요. 어쩌면 현대축구에서 가장 무서운 포지션이죠.',
                        "보이지 않는 ‘발’",
                        '수비형 미드필더는 지능적인 움직임과 전술 이해도를  바탕으로 움직이는 역할인만큼 팀에서 가장 중요하고, 가장 티 안 나게 위협적인 포지션이예요. 빠르지 않고, 퍼포먼스가 부족하다고 해서 없어도 될 포지션은 아닌 것입니다.',
                        '',
                        '가운데 세워진 벽이 공격수를 자유롭게 따라다녀요. 무서운 벽이죠. 공이 오는 것들을 모두 잘라내고 볼을 가지고 난 후부터 바로 공격이 시작되는 거예요. 수비적인 역할만 할 거라고 생각하면 안돼요. 어쩌면 현대축구에서 가장 무서운 포지션이죠.',
                        '진짜 위험한 것은 근처에 있다.',
                        '보이지 않는 ‘발’',
                        '중원과 후방 쪽의 수비를 지원하면서 상대팀의 중추를 끊어내는 그라운드의 진정한 ‘숨은 고수’ ' + this.nic_name + ' 회원님! 수비형 미드필더라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_dm_안드레아 피를로.png'),
                        require('@/assets/myposition_dm_세르히오 부스케츠.png'),
                        require('@/assets/myposition_dm_안드레아 피를로.png'),
                        require('@/assets/myposition_dm_로드리.png'),
                        require('@/assets/myposition_dm_카세미루.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_dm.svg'),
                        require('@/assets/pro_img/myposition_dm.png')
                    ],
                    names: [
                        '', '세르히오 부스케츠', '안드레아 피를로', '로드리', '카세미루'
                    ],
                    titleImage: require(`@/assets/img/position_DM.png`)
                },
                WB: {
                    explanation: [
                        '윙백',
                        'Wing Back',
                        '윙백 (WB-RWB/LWB)',
                        '"최고의 공격은<br>최고의 수비다."',
                        '호베르트 카를로스',
                        '제트엔진이 달린 강철 날개',
                        '뛰어난 체력과 지구력, 스피드를 바탕으로 공격적인 플레이를 전개하는 윙백 (LWB,RWB)은 윙 포워드, 측면 미드필더에 준하는 퍼포먼스와 활동량을 자랑하며, 측면에서 빠르고 직접적인 공격 전개를 이끌어 나가는 역할을 해요.',
                        '풀백과 비슷한 점이 있지만, 전술적으로 활동하는 위치와 역할이 다르므로, 두 포지션이 완전히 같다고는 할 수 없죠. 미드필더 위치 (2선)까지 올라와 활동하기 때문에 공격을 전개하는 것이 주된 목표인 역할이예요. 그만큼 빠른 스피드와 퍼포먼스가 요구되며 킥력, 마무리 능력도 좋아야 하죠.',
                        '비행기 날개처럼 튼튼하고 빠르게 움직여요. 상황에 따라서는 폭격을 하듯 공을 차거나, 상대 수비와의 도그 파이트에서도 지지 않는 개인기량과 퍼포먼스를 보여줘요. 사실상 수비수라는 생각보다는 또 하나의 공격수라는, ‘숨어 있는 스텔스기’라는 생각을 해야 하죠.',
                        '가짜 윙백',
                        '현대축구에서 ‘폴스 윙/풀백’이 주요 공격 자원으로 활용되는데, 윙백, 풀백의 위치상의 역할을 파괴해 측면에서 전방 안쪽까지  침투해 공격 빌드업에 가담하여 플레이를 만드는 역할을 합니다.',
                        '',
                        '비행기 날개처럼 튼튼하고 빠르게 움직여요. 상황에 따라서는 폭격을 하듯 공을 차거나, 상대 수비와의 도그 파이트에서도 지지 않는 개인기량과 퍼포먼스를 보여줘요. 사실상 수비수라는 생각보다는 또 하나의 공격수라는, ‘숨어 있는 스텔스기’라는 생각을 해야 하죠.',
                        '가짜 윙백',
                        '또 하나의 공격 자원',
                        '마치 축지법을 쓰듯 빠르고 폭발적인 움직임으로 단숨에 골키퍼 코 앞까지 치고 나가는 퍼포먼스와 기량을 갖춘  ' + this.nic_name + ' 회원님! 윙백 (LWB,RWB)이라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_wb_호베르트 카를로스.png'),
                        require('@/assets/myposition_wb_마르셀루.png'),
                        require('@/assets/myposition_wb_알폰소 데이비스.png'),
                        require('@/assets/myposition_wb_주앙 칸셀루.png'),
                        require('@/assets/myposition_wb_호베르트 카를로스.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_wb.svg'),
                        require('@/assets/pro_img/myposition_wb.png')
                    ],
                    names: [
                        '', '마르셀루', '알폰소 데이비스', '주앙 칸셀루', '호베르트 카를로스'
                    ],
                    titleImage: require(`@/assets/img/position_WB.png`)
                },
                FB: {
                    explanation: [
                        '풀백',
                        'Full Back',
                        '풀백 (FB)',
                        '"풀백으로 뛰면서 그는 왼쪽 측면을<br>아예 자기 소유로 만들어 버리곤 했다."',
                        '필리포 갈리',
                        '측면의 수호자',
                        '윙백과 마찬가지로 빠른 스피드와, 체력을 바탕으로 측면에서 윙어를 전담하여 저지하는 풀백 (LB,RB)은 윙백보다는 좀 더 수비적인 위치에서 중앙 수비수를 지원하고, 측면 공격 전개를 집중적으로 막아내는 역할을 해요.',
                        '공격시에는 전방으로 올라가 공격에도 가담하고 다시 수비진영 까지 빠르게 내려올 수 있어야 하기에, 빠른 스피드와 좋은 체력 혹은 피지컬이 요구되죠. 주로 측면을 수호하는 역할을 하기에 수비적인 기술 (태클, 압박, 대인 방어 등)이 요구되며, 현대 축구에서는 상황에 따라 좋은 킥력과 돌파력도 겸비해야 하는 상당히 중요한 자원이죠.',
                        '영화에서나 볼법한 숨막히는 추격씬을 보는 것 같죠. 상대팀에서 가장 발이 빠른 사람을 막으러 다녀야 하니까요 상황에 따라서는 직접 공을 운반하기도 해요. 굉장한 퍼포먼스를 보여주며, 공격에 가담하는 거죠. 측면을 수호하면서 공격을 돕는 아주 좋은 서포터예요.',
                        "현대축구에서 가장 중요한 것은 ‘풀백’이다.",
                        '사실 대부분의 선수가 기피하고 다른 포지션에 비해 실력이 아주 뛰어나진 않는 선수가 가야하는 비운의 위치이지만, 오히려 월드클래스로서 빛날 수 있는 희소성을 가진 포지션이죠. 그렇기 때문에 최근들어 공격 성향을 탑재한 풀백을 전술적으로 이용하는 추세죠.',
                        '',
                        '영화에서나 볼법한 숨막히는 추격씬을 보는 것 같죠. 상대팀에서 가장 발이 빠른 사람을 막으러 다녀야 하니까요. 상황에 따라서는 직접 공을 운반하기도 해요. 굉장한 퍼포먼스를 보여주며, 공격에 가담하는 거죠. 측면을 수호하면서 공격을 돕는 아주 좋은 서포터예요.',
                        '올라운더 플레이',
                        '오버래핑 장인',
                        '상황에 따라 공격, 수비를 빠르게 오가며 팀을 지원하는 역할을 하시는군요! 좋은 판단과 행동력을 갖춘 ' + this.nic_name + ' 회원님! 풀백 (LB,RB)이라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_fb_파울로 말디니.png'),
                        require('@/assets/myposition_fb_아슈라프 하키미.png'),
                        require('@/assets/myposition_fb_카푸.png'),
                        require('@/assets/myposition_fb_트렌트 알렉산더-아놀드.png'),
                        require('@/assets/myposition_fb_파울로 말디니.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_fb.svg'),
                        require('@/assets/pro_img/myposition_fb.png')
                    ],
                    names: [
                        '', '아슈라프 하키미', '카푸', '트렌트 알렉산더-아놀드', '파울로 말디니'
                    ],
                    titleImage: require(`@/assets/img/position_FB.png`)
                },
                CB: {
                    explanation: [
                        '센터백',
                        'Center Back',
                        '센터백 (CB)',
                        '"공은 내 앞에서 멈춘다"',
                        '파비오 칸나바로',
                        '헌신적인 방패',
                        '큰 키와 누구와도 지지 않을만큼 강하고 튼튼한 신체, 좋은 시야와 발 밑 기술을 토대로 고도의 집중력을 발휘하는 센터백 (CB)은 페널티 라인 밖에서 공과 선수를 차단하고, 수비 상황을 조율하며 세트피스 상황시 큰 키를 활용해 득점을 올리기도 하는 등의 역할을 해요.',
                        '전방 압박이 주요 전술 트렌드인 현대 축구에서 발 기술 또한 중요해졌으며, 조금이라도 방심을 하면 안되는 상황에 이르렀죠. 좋은 체격에 걸맞게 도전적으로 방어하는 역할을 하기에 높은 수준의 수비 능력 (태클, 압박, 대인 방어 등)이 요구되며, 상황에 따라 단순히 걷어내는 게 아닌 공격까지 전개될 수 있도록 정확한 킥 능력 또한 요구되죠.',
                        '패널티 라인 밖을 무섭도록 정교하게 수호하고 있어요. 초집중 상태에서 발을 들이밀고, 몸을 저돌적으로 붙이죠. 맞서 싸우거나 도망가거나 둘 중 하나를 선택하면 되지만, 도망갈 수밖에 없어요. 누구나 그럴 거죠. 까마득히 커다란 거인들이 길을 막고 서있으니까요.',
                        '세트피스 상황의 주인공',
                        '큰 체격을 가진 센터백은 세트피스 상황에서 높은 제공권을  가지고 있어요. 따라서 볼을 걷어내거나, 골을 넣는 역할에 특화되어 있죠. 어느 순간에서나 고도의 집중력을 발휘해야 되는 포지션인만큼 난이도가 굉장히 높은 포지션이예요.',
                        '',
                        '패널티 라인 밖을 무섭도록 정교하게 수호하고 있어요. 초집중 상태에서 발을 들이밀고, 몸을 저돌적으로 붙이죠. 맞서 싸우거나 도망가거나 둘 중 하나를 선택하면 되지만, 도망갈 수밖에 없어요. 누구나 그럴 거죠. 까마득히 커다란 거인들이 길을 막고 서있으니까요.',
                        '세트피스 상황의 주인공',
                        '좋은 체격으로 만든 벽',
                        '우월한 체격 조건을 이용해 상대팀의 공격을 최후방에서 막아내고, 경기 상황을 잘 읽으며 골대를 수호하는 ' + this.nic_name + ' 회원님! 센터백이라는 포지션을 추천합니다.'
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_cb_세르히오 라모스.png'),
                        require('@/assets/myposition_cb_김민재.png'),
                        require('@/assets/myposition_cb_버질 반 다이크.png'),
                        require('@/assets/myposition_cb_세르히오 라모스.png'),
                        require('@/assets/myposition_cb_파비오 칸나바로.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_cb.svg'),
                        require('@/assets/pro_img/myposition_cb.png')
                    ],
                    names: [
                        '', '김민재', '버질 반 다이크', '세르히오 라모스', '파비오 칸나바로'
                    ],
                    titleImage: require(`@/assets/img/position_CB.png`)
                },
                GK: {
                    explanation: [
                        '골키퍼',
                        'Goal Keeper',
                        '골키퍼 (GK)',
                        '"골키퍼는 골을 허용하는 게 괴로워야 한다. 골을 허용하고도 아무렇지 않은 골키퍼가 있다면 그에게는 어떤 미래도 없다."',
                        '레프 야신',
                        '최후방의 가디언',
                        '경기장 내에서 유일하게 손을 쓸 수 있는 포지션인 골키퍼 (GK)는 시합 중에 상대 선수의 강하고 빠른 공을 누구보다 많이 마주하기에 순발력, 반사 신경, 상황 판단 등이 매우 중요해요. 뿐만 아니라 최후방에서 수비수의 위치를 조율해야 하고, 역습 시에는 공격 진영에 빠르고 정확하게 볼을 전달해야 하므로 의사 소통 능력 또한 필요하죠.',
                        '현대 축구에서 골키퍼는 단순히 골대를 지키는 것을 넘어서서, 수비 뒷공간을 커버하고 롱 패스를 이용한 빌드업까지 맡게 되는 경우가 많아졌어요. 그래서 강한 킥력과 패스 정확도도 골키퍼를 평가하는 매우 중요한 요소가 되었죠. 골키퍼라면 당연히 골을 잘 막는 것이 제일 중요하겠지만 현대 축구에서 전술적으로 가장 많이 발전한 포지션인 만큼, 그 역할에 대한 가능성이 무궁무진한 포지션이에요.',
                        '“잘 차고 잘 막았다!” 하지만 아무리 절묘한 위치로 환상적인 슛을 차도 골키퍼가 잡아냈다면 점수는 올라가지 않아요. 같은 의미로 몇 명의 수비수를 현란한 드리블로 제쳤든 골키퍼를 뚫지 못했다면 무용지물이죠. 골키퍼가 실점하지 않는다면 경기에서 패배하는 일은 결코 일어나지 않아요.',
                        '등 뒤에서 팀을 받치는 리더',
                        '강력한 공을 막아내기 위해서는 몸을 날리는 다이빙 뿐만 아니라 직접적으로 신체가 부딪히는 볼경합도 벌여야 하는 만큼, 골문을 지키기 위해서는 두려움을 이겨내는 것이 중요해요. 게다가 넓은 골대를 전부 커버하기 위해서는 신체 조건 또한 받쳐줘야 하죠.',
                        '',
                        '“잘 차고 잘 막았다!” 하지만 아무리 절묘한 위치로 환상적인 슛을 차도 골키퍼가 잡아냈다면 점수는 올라가지 않아요. 같은 의미로 몇 명의 수비수를 현란한 드리블로 제쳤든 골키퍼를 뚫지 못했다면 무용지물이죠. 골키퍼가 실점하지 않는다면 경기에서 패배하는 일은 결코 일어나지 않아요.',
                        '등 뒤에서 팀을 받치는 리더',
                        '수비의 지휘자',
                        '뛰어난 리더십으로 수비를 지휘하고, 훌륭한 신체 능력을 십분 발휘해 가장 위험한 일을 도맡아 하는 ' + this.nic_name + ' 회원님! 골키퍼라는 포지션을 추천합니다.',
                    ],
                    images: [
                        require('@/assets/pro_img/myposition_gk_마누엘 노이어.png'),
                        require('@/assets/myposition_gk_마누엘 노이어.png'),
                        require('@/assets/myposition_gk_잔루이지 부폰.png'),
                        require('@/assets/myposition_gk_티보 쿠르투아.png'),
                        require('@/assets/myposition_gk_잔루이지 돈나룸마.png'),
                    ],
                    images_pos: [
                        require('@/assets/pro_img/myposition_gk.svg'),
                        require('@/assets/pro_img/myposition_gk.png')
                    ],
                    names: [
                        '', '마누엘 노이어', '잔루이지 부폰', '티보 쿠르투아', '잔루이지 돈나룸마'
                    ],
                    titleImage: require(`@/assets/img/position_GK.png`)
                }
            }
        }
    },
    data() {
        return {
            isShowHealth: false,
            isShowBallCont: false,
            isShowPass: false,
            isShowMainForce: false,
            isShowEyeSight: false,
            FIND_POSITION_PRO_TITLE: FIND_POSITION_PRO_TITLE,
            feedBackContents: {
                health: {
                    good: {
                        title: '좋은 체력을 가지셨군요. 체력을 더 키울 수 있는 약간의 피드백만 드려도 괜찮겠어요.',
                        subTitle: '와우! 산소통을 들고 다니시나요?',
                        contents: '축구는 순간적인 움직임이 많습니다. 그리고 상황에 따라 불규칙하게 체력이 소모되는 경향이 있죠. 이 때문에 상황에 따라 호흡법이 달라 질 수 있습니다. 일정하게만 뛰는 체력 중심 훈련보다는 경기를 중심으로 훈련하셔서 순간적인 움직임에 대한 이해도를 높이고, 경기 시 발생하는 상황들을 많이 접하면서 체력을 키우는 것이 중요하겠네요.',
                        img_path: require('@/assets/pro_img/health_good.svg')
                    },
                    bad: {
                        title: '체력 훈련이 좀 필요해 보여요. 체력 훈련을 위한 적당한 피드백을 준비했으니 참고하셔도 괜찮겠어요! ',
                        subTitle: '이런! 힘들고 지치는 경우가 많군요',
                        contents: '체력이 좋지 않은 경우에는 오히려 러닝 같은 체력 훈련보다는 시합을 자주해야 해요. 실질적인 경기 체력을 늘리는 것이 더 중요하기 때문이죠. 따라서 경기를 오래 뛰는 훈련이 보다 효과적입니다. 또한 축구는 순간적인 움직임이 많습니다. 그리고 상황에 따라 불규칙하게 체력이 소모되는 경향이 있죠.  이 때문에 상황에 따라 호흡법이 달라 질 수 있습니다. 일정하게만 뛰는 체력 중심 훈련보다는 경기를 중심으로 훈련하셔서 순간적인 움직임에 대한 이해도를 높이고, 경기 시 발생하는 상황들을 많이 접하면서 체력을 키우는 것이 중요하겠네요.',
                        img_path: require('@/assets/pro_img/health_bad.svg')
                    }
                },
                ball_control: {
                    good: {
                        title: '공을 자유롭게 컨트롤 할 수 있는 좋은 공 제어 감각을 가지고 계시군요! 소소한 피드백을 참고해보시는 건 어떨까요?',
                        subTitle: '공이 발에서 안 떨어지시는군요!',
                        contents: '공을 잘 제어하려면 인스텝, 인사이드, 아웃사이드 부분의 감각을 모두 이용해야 합니다. 아무리 드리블 능력이 좋아도 막상 인스텝, 인사이드, 아웃사이드의 감각은 모르는 경우가 있기 때문에 리프팅 을 통해 발의 감각을 고르게 발달시키는 것이 가장 중요해요.',
                        img_path: require('@/assets/pro_img/ball_cont_good.svg')
                    },
                    bad: {
                        title: '공을 잘 다뤄보고 싶지만 그게 잘 안되시나요? 좋은 피드백을 준비했으니 한번 참고해보시면 좋겠어요!',
                        subTitle: '공은 굴러가고 발은 안 움직이나요?',
                        contents: '공을 잘 제어하려면 인스텝, 인사이드, 아웃사이드 부분의 감각을 모두 이용해야 합니다. 따라서 인스텝, 인사이드, 아웃사이드의 감각이 고르게 발달하도록 훈련하시길 권장해요. ',
                        subTitle2: '인스텝의 감각을 키우는 훈련',
                        contents2: '인스텝의 감각 훈련은 흔히 ‘리프팅’ 또는 ‘저글링’이라고 하는데, 리프팅을 100개 이상 차는 것을 목표로 꾸준히 반복해서 훈련하시길 바래요.',
                        subTitle3: '인사이드와 아웃사이드의 감각을 키우는 훈련',
                        contents3: '좁은 공간에서 인사이드와 아웃사이드를 활용해 지속적으로 공을 밀어내고 잡는 드리블 연습을 해보세요! 이 연습을 자주 하게 되면, 발목을 자유롭고 자연스럽게 컨트롤 할 수 있는 미세 근육들이 발달하고, 발목에 힘이 생기게 돼요. 나중에는 발에 공을 붙여놓은 것처럼 안 떨어지게 될지도 모르죠!',
                        img_path: require('@/assets/pro_img/ball_cont_bad.svg')
                    }
                },
                pass: {
                    good: {
                        title: '그라운드 어디에도 공을 정확하게 전달할 수 있는 대단한 패스 능력을 보유하고 계시네요! 다만 지금보다 좀 더 프로처럼 보이게 할 수 있는 피드백도 한번 참고해주시면 어떨까요?',
                        subTitle: '패스를 좀 더 마법처럼!',
                        contents: '지금보다 조금 더 패스와 킥을 맛있게 할 수 있는 방법이 있어요. 패스/킥을 할 시에는 사용하는 발의 부위에 공이 정확하게 맞는 것이 중요해요. 그렇게 하기 위해서는 발목이 제대로 고정이 될 수 있도록 힘을 주는 방법과 감각을 익혀나가야 하죠.',
                        subTitle2: '킥 훈련',
                        contents2: '킥은 발등 부위 (인스텝)이 고정되어 있어야 해요. 리프팅은 인스텝의 감각을 키우는 데에 아주 도움이 되는 훈련이죠. 한 번씩 공을 차고 손으로 잡는 걸 반복하면서, 공을 발등에 정확히 맞추는 방법을 훈련할 수 있어요. 이때 공을 찬 후 공이 공중에서 돌지 않는다면 발등이 잘 고정되어 있고 발등에 정확하게 맞았다는 것을 의미합니다. 이렇게 발등을 고정한 후에 킥을 해보는 연습까지 진행하시면 좋아요. 공에 강한 힘을 전달해도 발목이 안 흔들리고, 백스윙 동작에서 생긴 힘을 그대로 전달하여 아주 예쁜 킥을 찰 수 있게 되죠!',
                        subTitle3: '패스 훈련',
                        contents3: '패스는 발목을 직각으로 세우고 인사이드가 정면을 보게 하는 것이 중요해요. 이때 디딤발의 위치도 아주 중요한데, 디딤발은 공 바로 옆에 발 1개가 더 들어갈 정도의 공간을 마련해둬요. 그리고 상체는 정면을 향한 상태를 유지해야 하죠. 이때 디딤발과 상체의 방향에 따라 패스 방향을 정할 수도 있어요. 어쨌든 기본 자세가 세팅이 되었다면, 공의 정중앙부위와 인사이드 중앙이 딱 맞도록 차줍니다. 딱 느낌이 오나요? ‘아 이게 패스구나!’ 하고요!',
                        img_path: require('@/assets/pro_img/pass_good.svg')
                    },
                    bad: {
                        title: '공을 발에 맞추는 개념에 대한 설명이 필요해보여요. 킥과 패스를 훈련할 수 있는 방법을 준비했으니 한번은 참고해주세요!',
                        subTitle: '분명 공을 줬는데 받은 사람이 없다구요?',
                        contents: '패스를 줬지만 받아본 사람이 없는 미스테리를 한번씩은 경험해보셨나요? 불행 중 다행으로 여러분의 안타까운 삼각발도 개선할 수 있는 방법이 있어요! 바로 발목 고정 메커니즘이죠. 킥은 발등이 고정되어야 하고, 패스는 인사이드 부위가 고정되어 있어야 해요.',
                        subTitle2: '킥 훈련',
                        contents2: '킥은 발등 부위 (인스텝)이 고정되어 있어야 해요. 리프팅은 인스텝의 감각을 키우는 데에 아주 도움이 되는 훈련이죠. 한 번씩 공을 차고 손으로 잡는 걸 반복하면서, 공을 발등에 정확히 맞추는 방법을 훈련할 수 있어요. 이때 공을 찬 후 공이 공중에서 돌지 않는다면 발등이 잘 고정되어 있고 발등에 정확하게 맞았다는 것을 의미합니다. 이렇게 발등을 고정한 후에 킥을 해보는 연습까지 진행하시면 좋아요. 공에 강한 힘을 전달해도 발목이 안 흔들리고, 백스윙 동작에서 생긴 힘을 그대로 전달하여 아주 예쁜 킥을 찰 수 있게 되죠!',
                        subTitle3: '패스 훈련',
                        contents3: '패스는 발목을 직각으로 세우고 인사이드가 정면을 보게 하는 것이 중요해요. 이때 디딤발의 위치도 아주 중요한데, 디딤발은 공 바로 옆에 발 1개가 더 들어갈 정도의 공간을 마련해둬요. 그리고 상체는 정면을 향한 상태를 유지해야 하죠. 이때 디딤발과 상체의 방향에 따라 패스 방향을 정할 수도 있어요. 어쨌든 기본 자세가 세팅이 되었다면, 공의 정중앙부위와 인사이드 중앙이 딱 맞도록 차줍니다. 딱 느낌이 오나요? ‘아 이게 패스구나!’ 하고요!',
                        img_path: require('@/assets/pro_img/pass_bad.svg')
                    },
                },
                eye_sight: {
                    good: {
                        title: '항상 고개를 들고 계시는군요! 주변에서 무슨 일이 벌어지고 있는지를 금방 파악하실 수 있겠어요.',
                        subTitle: '와우! 미어캣인가요?',
                        contents: '공을 받기 전부터 주변을 살피고 우리팀 선수들의 위치를 바로바로 캐치하시는군요! 너무 훌륭한 파수꾼 역할을 하고 있으시네요. 마치 미어캣처럼요! 공을 주고받을 때 항상 주변을 살피는 연습을 꾸준히 한다면 정말 훌륭한 시야를 얻을 수 있어요. 패스 타이밍에 대한 이해도가 같이 느는 건 덤이구요.',
                        img_path: require('@/assets/pro_img/eye_sight_good.svg')
                    },
                    bad: {
                        title: '넓고 정확하게 보는 시야에 대한 훈련이 필요해보이네요. 습관을 꼭 들이면 좋은 훈련이니 꼭 참고해주시면 좋겠어요!',
                        subTitle: '주변을 자주 살필 필요가 있어요.',
                        contents: '횡단보도를 건널 때를 떠올려보세요. 우회전 차량이 있는지, 오토바이가 오는지, 사람이 얼마나 오가는지를 살피면서 가곤 하죠. 물론 상황에 따라 다르겠지만요. 그렇게 주변을 살피는 훈련을 한다고 생각하면 편해요! ',
                        subTitle2: '시야 훈련',
                        contents2: '패스 훈련을 하거나 드리블 훈련 등을 할 때 공에만 시선을 고정하지 말고, 가능한 고개를 들어서 공과 정면, 좌,우를 잠깐이라도 흘겨 보도록 연습합니다. 공에만 시선을 집중하면 시야가 명확하게 좁아지고 패스를 할 타이밍도 놓치게 되기 때문이죠.',
                        subTitle3: '상황 인지 훈련',
                        contents3: '공을 주거나 잡았을 때는 항상 주변을 살펴야 하죠. 내 위치, 상대 위치, 우리팀의 위치를 파악해야 하니까요. 공이 본인에게로 굴러오는 게 두렵거나 긴장하는 사람일지라도 근본적인 두려움은 내 주변에 누가 다가오지 않을까 하는 것에서 비롯되는만큼, 주변을 꼭 살피는 연습을 해야 해요. 일종의 공 받기 전 꼭 해야 하는 행동 루틴처럼요!',
                        img_path: require('@/assets/pro_img/eye_sight_bad.svg')
                    }
                },
                speed: {
                    good: {
                        title: '발이 너무 빨라서 안 보일 정도군요! 선천적으로 주력이 빠르신 분이라고 생각해요. 여기서 순발력 훈련만 더 한다면 알폰소 데이비스 선수처럼 매우 빠른 사람이 될 수도 있겠군요!',
                        subTitle: '치타만큼 빠르시군요!',
                        contents: '선천적으로 타고난 주력을 가지고 계시는군요. 빠른 달리기가 주된 장점이라고 해도 무방하겠어요. 축구는 순간적으로 빠르게 움직여야 하는 상황들이 많다보니 순발력에 대한 훈련도 병행하시면 정말 빠른 선수가 될 수 있울 거예요.',
                        subTitle2: '순발력 훈련',
                        contents2: '줄넘기는 순간 가속을 내는 데에 아주 효과적입니다. 줄넘기를 하다보면 걸려 넘어질 것 같은 순간에 빠르게 다시 뛰곤 하죠. 이때 발목과 종아리에 탄력이 생기면서 순간적으로 빠른 움직임을 만들어낼 수 있어요. 축구에서도 이를 적용한다면 순간적인 상황에서 빠르게 움직일 수 있는 순발력이 생기는 것이죠! 순간적으로 빠르게 움직일 수만 있어도 기본 주력이 빠른 선수들 못지 않는 가속도를 낼 수 있어요. 그리고 가속도를 이끌어내는 다리 근육 (허벅지, 힙)을 같이 운동해줘야 하죠.',
                        img_path: require('@/assets/pro_img/speed_good.svg')
                    },
                    bad: {
                        title: '주력이 아주 뛰어나진 않으시지만, 충분한 훈련만으로도 굉장한 스피드를 낼 수 있어요. 천재적으로 빠른 사람들을 이길 수 있는 유일한 방법을 훈련해보세요!',
                        subTitle: '스피드 차이는 순발력으로 극복!',
                        contents: '주력은 선천적으로 타고나는 사람들이 있어요. 도저히 따라잡을 수 없을 것 같은 선수들이지만 후천적으로도 스피드를 끌어올릴 수 있는 방법이 있어요. 축구는 긴 거리를 오래 뛰는 상황이 없기 때문에 단거리를 순간적으로 뛰는 순발력을 키우는 훈련이 필요하죠.',
                        subTitle2: '순발력 훈련',
                        contents2: '줄넘기는 순간 가속을 내는 데에 아주 효과적입니다. 줄넘기를 하다보면 걸려 넘어질 것 같은 순간에 빠르게 다시 뛰곤 하죠. 이때 발목과 종아리에 탄력이 생기면서 순간적으로 빠른 움직임을 만들어낼 수 있어요. 축구에서도 이를 적용한다면 순간적인 상황에서 빠르게 움직일 수 있는 순발력이 생기는 것이죠! 순간적으로 빠르게 움직일 수만 있어도 기본 주력이 빠른 선수들 못지 않는 가속도를 낼 수 있어요. 그리고 가속도를 이끌어내는 다리 근육 (허벅지, 힙)을 같이 운동해줘야 하죠.',
                        img_path: require('@/assets/pro_img/speed_bad.svg')
                    },
                }
            },
            position: '',
            img_path: null,
            left: 0,
            fade1: false,
            fade2: false,
            fade3: false,
            showPosition: false,
            signalCloseDetail: false,
            saveLeft: '',
            saveIndex: -1,
            copy_picture_left: 0,
            copy_picture_top: 0,
            prev_copy_picture_left: 0,
            prev_copy_picture_top: 0,
            picture_top_gap: 70,
            copy_picture_big_size: 220,
            copy_picture_small_size: 160,
            copy_picture_width: 160,
            isShowPositions: false,
            isShowPositionPictures: true,
            curSelectedPictureIndex: -1,
            copy_picture_scale_x: 1,
            positionPictureOpacity: 1,
            isShowCopyPicture: false,
            isShared: false,
            health_good: 0,
            health_bad: 0,
            eye_sight_good: 0,
            eye_sight_bad: 0,
            pass_good: 0,
            pass_bad: 0,
            ball_cont_good: 0,
            ball_cont_bad: 0,
            main_force_good: 0,
            main_force_bad: 0,
            isHealthBad: false,
            isEyeSightBad: false,
            isMainForceBad: false,
            isBallContBad: false,
            isPassBad: false,
            isCloseElement: false,
            nic_name: ''
        }
    },
    created() {
        this.nic_name = this.$GlobalStore.isLogin() ? this.$GlobalStore.loginInfo().nic_name : '';
        this.applyProPosition = this.$Once(this.applyProPosition)
        const totalScore = 20
        const passScore = 25
        
        const health = (this.groupedData[FIND_POSITION_PRO_TITLE.HEALTH] / totalScore) * 100
        const eyeSight = (this.groupedData[FIND_POSITION_PRO_TITLE.EYESIGHT] / totalScore) * 100
        const mainForce = (this.groupedData[FIND_POSITION_PRO_TITLE.MAIN_FORCE] / totalScore) * 100
        const pass = (this.groupedData[FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT] / passScore) * 100
        const ballCont = (this.groupedData[FIND_POSITION_PRO_TITLE.BALL_CONTROL] / totalScore) * 100

        this.health_good = Math.ceil(health)
        this.health_bad = Math.floor(100 - health)

        this.eye_sight_good = Math.ceil(eyeSight)
        this.eye_sight_bad = Math.floor(100 - eyeSight)

        this.main_force_good = Math.ceil(mainForce)
        this.main_force_bad = Math.floor(100 - mainForce)

        this.pass_good = Math.ceil(pass)
        this.pass_bad = Math.floor(100 - pass)

        this.ball_cont_good = Math.ceil(ballCont)
        this.ball_cont_bad = Math.floor(100 - ballCont)

        if (this.health_bad > this.health_good) {
            this.isHealthBad = true
        }

        if (this.eye_sight_bad > this.eye_sight_good) {
            this.isEyeSightBad = true
        }

        if (this.main_force_bad > this.main_force_good) {
            this.isMainForceBad = true
        }

        if (this.pass_bad > this.pass_good) {
            this.isPassBad = true
        }

        if (this.ball_cont_bad > this.ball_cont_good) {
            this.isBallContBad = true
        }


        this.showPosition = true
        switch (this.positionsArr[0].position) {
            case 'LWF':
            case 'RWF':
                this.position = 'WF'
                break;
            case 'LM':
            case 'RM':
                this.position = 'WM'
                break;
            case 'LWB':
            case 'RWB':
                this.position = "WB"
                break;
            case "LB":
            case "RB":
                this.position = "FB"
                break;
            default: this.position = this.positionsArr[0].desc
        }

        const forceCloseConfirm = () => {
            setTimeout(() => {
                this.$GlobalStore.addPopFlag(forceCloseConfirm);
                this.prevBack();
            }, 0)
        };

        this.$GlobalStore.addPopFlag(forceCloseConfirm);

        this.img_path = this.result[this.position]?.images[0];


    },
    mounted() {

    },
    methods: {
        closeFindPositionPro() {
            this.$GlobalStore.closeModalAll()
            if (!this.isFromProfile) {
                if (this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                    this.$router.push({ path: '/view/soccer_join' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                } else {
                    this.$GlobalStore.setIsShowAfterPositionPopup(true, false)
                }
            }
        },
        startPositionLite() {
            this.$Util.showBrowser('https://positionfinder.kr/view/position_web')
        },
        detectElement() {
            if (this.isCloseElement) {
                return
            }
            const outerElement = this.$refs.wrapper
            const targetElement = this.$refs.ability_element
            const targetRect = targetElement.getBoundingClientRect();

            if (targetRect.top <= outerElement.clientHeight && targetRect.bottom >= 0) {
                this.isCloseElement = true
            }
        },
        closeConfirm() {
            if (this.isConfirmDirectClose) {
                if (this.$GlobalStore.checkViewExist('MyPositionProMain')) {
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.closeLastModal();
                }
                this.$GlobalStore.closeLastModal();
            } else if (this.showPosition) {
                this.prevBack();
            } else {
                this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">뒤로가기</strong><br>포지션 찾기 프로를 진행중입니다.<br>결과창에서 포지션을 저장할 수 있으며, 지금까지의 내용은 저장되지 않습니다.<br>또한 임의로 중단하실 시 결제하신 내용은 환불받으실 수 없습니다.<br>정말 중단하고 뒤로 이동할까요?', async () => {
                    if (this.$GlobalStore.checkViewExist('MyPositionProMain')) {
                        this.$GlobalStore.closeLastModal();
                        this.$GlobalStore.closeLastModal();
                    }
                    this.$GlobalStore.closeLastModal();
                }, '뒤로 가기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2);
            }
        },
        async getShareUrl() {
            const groupDataArr = [
                this.groupedData[FIND_POSITION_PRO_TITLE.HEALTH],
                this.groupedData[FIND_POSITION_PRO_TITLE.EYESIGHT],
                this.groupedData[FIND_POSITION_PRO_TITLE.MAIN_FORCE],
                this.groupedData[FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT],
                this.groupedData[FIND_POSITION_PRO_TITLE.BALL_CONTROL],
            ];

            const parameters = {};
            parameters.position = this.position;
            parameters.group_data = groupDataArr.join(',');

            const res = await this.$Axios.get('/api/share/position/pro/url', { params: parameters });
            // console.log(res.data.url);
            const message = '';
            const url = res.data.url;
            const device = this.$cookies.get('device');
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            }
        },
        async applyProPosition() {
            this.$GlobalStore.showProgress()

            const groupDataArr = [
                this.groupedData[FIND_POSITION_PRO_TITLE.HEALTH],
                this.groupedData[FIND_POSITION_PRO_TITLE.EYESIGHT],
                this.groupedData[FIND_POSITION_PRO_TITLE.MAIN_FORCE],
                this.groupedData[FIND_POSITION_PRO_TITLE.PASS_KICK_SHOOT],
                this.groupedData[FIND_POSITION_PRO_TITLE.BALL_CONTROL],
            ];

            const parameters = {};
            parameters.is_pro = true;
            parameters.position = this.position;
            parameters.position_pro_ability = groupDataArr.join(',');
            parameters.is_direct_position = 0;
            if (this.position_result_history_group_key) parameters.position_result_history_group_key = this.position_result_history_group_key;

            const res = await this.$Axios.post('/api/position/save', parameters);
            this.$GlobalStore.hideProgress()
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$Util.sendEventClick('포지션찾기_프로필적용', true)
                localStorage.removeItem('savePositionTimePro')
                localStorage.removeItem('POSITION_TYPE')
                localStorage.removeItem('positionArr')
                localStorage.removeItem('groupData')
                localStorage.removeItem('scores')
                this.$GlobalStore.closeModalAll();
                if (this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                    this.$router.push({ path: '/view/my' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                } else {
                    this.$GlobalStore.setIsShowAfterPositionPopup(true, true)
                }
                // this.$GlobalStore.addModal('ShowProfileCard', { mode: MY_VIEW_MODE.ME, memberIdx: this.$GlobalStore.loginInfo().idx, })
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        closeModal() {
            this.isShowHealth = false
            this.isShowBallCont = false
            this.isShowMainForce = false
            this.isShowEyeSight = false
            this.isShowPass = false
        },
        showFeedHealth() {
            this.isShowHealth = true
        },
        showFeedBallCont() {
            this.isShowBallCont = true
        },
        showFeedPass() {
            this.isShowPass = true
        },
        showFeedEyeSight() {
            this.isShowEyeSight = true
        },
        showFeedMainForce() {
            this.isShowMainForce = true
        },
        prevBack() {
            this.$GlobalStore.closeModalAll()
            // this.signalCloseDetail = !this.signalCloseDetail;
            // this.showPosition = false;
            // this.isShared = false;
            this.isCloseElement = false
        },
        showResult(left, i) {
            this.saveLeft = left
            this.saveIndex = i
            this.isShared = true
            this.showPosition = true
        },
        showPositionResult(desc, i, img_path) {
            this.curSelectedPictureIndex = i;
            this.isShowCopyPicture = true;
            this.positionPictureOpacity = 0;
            this.isShowPositionPictures = false;

            const rect = this.$refs.images[i].getBoundingClientRect();

            this.copy_picture_left = rect.left;
            this.copy_picture_top = rect.top;

            this.prev_copy_picture_left = rect.left;
            this.prev_copy_picture_top = rect.top;

            this.copy_picture_width = this.copy_picture_small_size;

            setTimeout(() => {
                this.copy_picture_scale_x = -1;
                this.copy_picture_width = this.copy_picture_big_size;
                this.copy_picture_top = this.picture_top_gap + 30;
                this.copy_picture_left = window.screen.width / 2 - this.copy_picture_big_size / 2
            }, 10)
            this.img_path = img_path;
            this.position = desc;
            this.showResult(this.left, i)

        },
    },
    watch: {
        signalCloseDetail() {
            this.isShowPositionPictures = true;
            this.copy_picture_scale_x = 1;
            setTimeout(() => {
                this.isShowCopyPicture = false;
                this.curSelectedPictureIndex = -1;
            }, 1000);

            setTimeout(() => {
                this.positionPictureOpacity = 1;
            }, 10)

            this.copy_picture_width = this.copy_picture_small_size;
            this.copy_picture_left = this.prev_copy_picture_left;
            this.copy_picture_top = this.prev_copy_picture_top;
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

.common_btn {
    width: calc(100% - 40px);
    line-height: 50px;
    text-align: center;
    background-color: #f5f5f5;
    border-radius: 12px;
    color: var(--color-main);
    margin: 0 auto;
    margin-top: 20px;
    font-weight: 700;
    font-size: 14px;
}

.sub_title2_modal {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 10px;
}

.sub_contents2_modal {
    font-weight: 400;
    font-size: 12px;
    color: #2d1304;
    line-height: 18px;
}

.sub_title_modal {
    text-align: center;
    margin-top: 23px;
    font-size: 20px;
    font-weight: 500;
}

.contents_modal {
    font-weight: 400;
    margin-top: 40px;
    line-height: 23px;
    font-size: 14px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.test-enter-active {
    animation: bounce-in .5s;
}

.test-leave-active {
    animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
    0% {
        left: 0%;
        top: 1px;
    }

    50% {
        left: 25%;
        top: 60px;
    }

    100% {
        left: 50%;
        top: 124px;
    }
}

.subTitle {
    font-size: 20px;
    margin-top: 32px;
    margin-bottom: 16px;
    line-height: 24px;
    font-weight: 500;
}

.explanation {
    font-size: 14px;
    line-height: 23px;
    font-weight: 500;
}

.player_name {
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    margin-top: 16px;
}

.circle {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 0px #00000040;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.many_image {
    /* justify-content: center; */
    padding-left: 35px;
    padding-right: 35px;
    gap: 12px;
    /*margin-bottom: 79px;*/
    /*margin-top: 59px;*/
    display: flex;
}

.one_image {
    text-align: center;
    margin-bottom: 48px;
    display: flex;
    justify-content: center;
}
</style>